module.exports = __webpack_public_path__ + "sunsemweb/img/banner1.cfc17c40.png";